'use client';

import { MessageCircle } from 'lucide-react';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useSidebar } from '@/contexts/SidebarContext';

export default function FloatingChatButton() {
    const { open } = useSidebar();
    const pathname = usePathname();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Don't show on admin pages
        if (pathname?.startsWith('/admin')) {
            setIsVisible(false);
            return;
        }

        // Reset visibility on pathname change to trigger the entry animation
        setIsVisible(false);
        const timer = setTimeout(() => setIsVisible(true), 1000);
        return () => clearTimeout(timer);
    }, [pathname]);

    if (!isVisible || pathname?.startsWith('/admin')) return null;

    return (
        <button
            type="button"
            onClick={() => open('submit')}
            className="fixed bottom-6 right-6 z-40 bg-brand hover:bg-brand-dark text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-[transform,background-color,box-shadow] duration-200 hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-dark focus-visible:ring-offset-2 group cursor-pointer animate-chat-pop"
            aria-label="Open inquiry form"
            title="Send us a message"
        >
            <MessageCircle className="w-6 h-6" aria-hidden="true" />
            <span
                className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse"
                aria-hidden="true"
            />
        </button>
    );
}
